"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _reactEmotion = require("react-emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var fadeIn = /*#__PURE__*/(0, _reactEmotion.keyframes)("from{opacity:0;transform:scale(0.9);}to{opacity:1;transform:scale(1);}");

var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var tetherProps = {
        attachment: "".concat(this.props.vertical === 'above' ? 'bottom' : 'top', " ").concat(this.props.horizontal),
        targetAttachment: "".concat(this.props.vertical === 'above' ? 'top' : 'bottom', " ").concat(this.props.horizontal),
        constraints: this.props.constraints,
        offset: this.props.offset || "".concat(this.props.vertical === 'above' ? '12' : '-12', " 0")
      };
      var bgColor = this.props.type === 'error' ? '#FF4D4D' : '#545C63';
      return this.props.hide ? this.props.children : /*#__PURE__*/_react.default.createElement(_reactTether.default, tetherProps, this.props.children, /*#__PURE__*/_react.default.createElement("div", {
        className: /*#__PURE__*/(0, _emotion.css)("background:", bgColor, ";color:white;border-radius:4px;box-shadow:0 4px 7px 0 rgba(84,92,99,0.23);padding:.75em 1em;position:relative;opacity:0;animation:", fadeIn, " .2s linear forwards;&:before{content:'';display:block;width:12px;height:12px;background:", bgColor, ";transform:rotate(45deg);position:absolute;top:", this.props.vertical === 'below' ? '-6px' : 'calc(100% - 6px)', ";left:", this.props.horizontal === 'center' ? 'calc(50% - 6px)' : this.props.horizontal === 'left' ? '12px' : 'calc(100% - 30px)', ";}"),
        ref: function ref(_ref) {
          return _this2.props.setTooltipInnerRef(_ref);
        }
      }, this.props.render));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Tooltip;
}(_react.default.Component);

Tooltip.defaultProps = {
  vertical: 'below',
  horizontal: 'left',
  hide: false,
  type: 'default',
  setTooltipInnerRef: function setTooltipInnerRef(ref) {
    return null;
  },
  constraints: [{
    to: 'window',
    attachment: 'together'
  }],
  offset: null
};
Tooltip.propTypes = {
  render: _propTypes.default.node.isRequired,
  children: _propTypes.default.node.isRequired,
  vertical: _propTypes.default.oneOf(['above', 'below']),
  horizontal: _propTypes.default.oneOf(['left', 'center', 'right']),
  hide: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['default', 'error']),
  setTooltipInnerRef: _propTypes.default.func,
  constraints: _propTypes.default.array,
  offset: _propTypes.default.string
};
var _default = Tooltip;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(fadeIn, "fadeIn", "/Users/darcy/sites/cs-theme/src/components/tooltip/index.js");
  reactHotLoader.register(Tooltip, "Tooltip", "/Users/darcy/sites/cs-theme/src/components/tooltip/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/tooltip/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();